import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CheckCircle2, AlertCircle, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Returns null when the name is free, otherwise the message explaining why it can't be used
export const checkEditorName = async (nome, excludeId) => {
  const { data } = await axios.get(`${API}/public/editor-name-available`, { params: { nome, ...(excludeId ? { exclude_id: excludeId } : {}) } });
  return data.available ? null : data.detail;
};

export const EditorNameHint = ({ nome, excludeId, initial }) => {
  const [state, setState] = useState(null);
  useEffect(() => {
    const value = (nome || '').trim();
    if (!value || value === (initial || '').trim()) { setState(null); return undefined; }
    setState({ loading: true });
    const t = setTimeout(() => {
      checkEditorName(value, excludeId).then((err) => setState({ err })).catch(() => setState(null));
    }, 500);
    return () => clearTimeout(t);
  }, [nome, excludeId, initial]);
  if (!state) return null;
  if (state.loading) return <span data-testid="editor-name-checking" style={{ fontSize: '0.78rem', color: '#718096', display: 'inline-flex', alignItems: 'center', gap: 4 }}><Loader2 className="w-3 h-3 animate-spin" />Verificando nome...</span>;
  return state.err
    ? <span data-testid="editor-name-taken" style={{ fontSize: '0.78rem', color: '#e53e3e', display: 'inline-flex', alignItems: 'flex-start', gap: 4 }}><AlertCircle className="w-3 h-3" style={{ flexShrink: 0, marginTop: 2 }} />{state.err}</span>
    : <span data-testid="editor-name-available" style={{ fontSize: '0.78rem', color: '#38a169', display: 'inline-flex', alignItems: 'center', gap: 4 }}><CheckCircle2 className="w-3 h-3" />Nome disponível</span>;
};
